
import { BotonCopiar } from '../../../../components/ButtonCopy';
import useClientesModel from '../../../../modelos/Clientes/modeloClientes';
import React, { useState , useEffect } from 'react';
import Select from 'react-select';

/**
 * Modal para solicitar el número de teléfono de un cliente antes de copiar una solicitud.
 * @param {object} props
 * @param {boolean} props.isOpen - Controla si el modal está visible o no.
 * @param {function} props.onClose - Función para cerrar el modal.
 * @param {function(string)} props.onCopy - Función que se ejecuta al confirmar. Recibe el número de teléfono.
 * @param {boolean} [props.isCopying=false] - Opcional. Si es true, muestra un estado de carga en el botón.
 */
function ModalCopiarSolicitud({ isOpen, onClose, onCopy, isCopying = false }) {
  const [error, setError] = useState('');
  const {busquedaClientesOptions,loadingClientes,handleInputChange,addCliente} = useClientesModel();
  const [formCliente, setFormData] = useState({
    cliente: '',
  });

  // --- Lógica para cerrar con Escape ---
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        handleClose();
      }
    };

    // Solo agregar el listener si el modal está abierto
    if (isOpen) {
      window.addEventListener('keydown', handleKeyDown);
    }

    // Limpieza del evento cuando el componente se desmonte o el modal se cierre
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen]); // Se ejecuta cada vez que 'isOpen' cambie
  // ---------------------------------------

  // No renderizar nada si el modal no está abierto
  if (!isOpen) {
    return null;
  }

  const handleConfirmCopy = () => {
    console.log(formCliente.cliente);
    // Validación simple
    if (!formCliente.cliente) {
      setError('Por favor, ingresa un número de teléfono.');
      return;
    }
    // Puedes agregar más validaciones aquí (ej. longitud, solo números)

    setError(''); // Limpiar errores
    onCopy(formCliente.cliente); // Ejecutar la función de copiado del padre
  };

  const handleClose = () => {
    // Resetear estado al cerrar
    setFormData({
      cliente: '',
    });
    setError('');
    onClose();
  };

  const getOptionFromValue = (options, value) => {
    if (!value || !options || options.length === 0) return null;
    return options.find(option => option.value === value) || null;
  };

  const handleSelectChange = (selectedOption, { name }) => {
    setFormData({
      ...formCliente,
      [name]: selectedOption ? selectedOption.value : ''
    });

  };

  return (
    // Fondo oscuro semi-transparente
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center p-4">
      
      {/* Contenedor del Modal */}
      <div className="bg-white rounded-lg shadow-2xl w-full max-w-md transform transition-all">
        
        {/* Encabezado del Modal */}
        <div className="flex justify-between items-center p-4 border-b border-gray-200">
          <h3 className="text-lg font-semibold text-gray-800">Copiar Solicitud</h3>
          <button 
            onClick={handleClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
            aria-label="Cerrar modal"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Cuerpo del Modal */}
        <div className="p-6">
          <p className="text-sm text-gray-600 mb-4">
            Ingresa el número de teléfono del cliente al que deseas copiar esta solicitud.
          </p>
          
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-3">
              Cliente
            </label>
            <Select
                  name="cliente"
                  value={getOptionFromValue(busquedaClientesOptions, formCliente.cliente)}
                  onChange={handleSelectChange}
                  onInputChange={handleInputChange}
                  options={busquedaClientesOptions}
                  placeholder="Selecciona el cliente"
                  isClearable
                  isSearchable
                  isLoading={loadingClientes}
                  loadingMessage={() => "Cargando clientes..."}
                  noOptionsMessage={() => "No se encontraron clientes"}
                  classNamePrefix="react-select"
                  className="react-select-container"
            />
            {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
          </div>
        </div>

        {/* Pie del Modal (Botones) */}
        <div className="flex justify-end items-center p-4 bg-gray-50 border-t border-gray-200 rounded-b-lg space-x-3">
          <button
            onClick={handleClose}
            className="px-4 py-2 bg-white border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 transition"
          >
            Cancelar
          </button>
          <button
            onClick={handleConfirmCopy}
            disabled={isCopying}
            className="px-4 py-2 bg-blue-600 border border-transparent rounded-md text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition disabled:bg-blue-300 disabled:cursor-not-allowed"
          >
            {isCopying ? 'Buscando...' : 'Buscar y Copiar'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ModalCopiarSolicitud;
